module.exports = __webpack_public_path__ + "static/img/A150.39291bee.jpg";